'use client';

// Third Party
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import cx from 'classnames';

// Local
import type { FaqItem } from './faq-data';

// UI
import { Typography } from '@components/typography';

interface FaqAccordionProps {
  faqItems: readonly FaqItem[];
}

export function FaqAccordion({ faqItems }: FaqAccordionProps) {
  return (
    <div className="divide-y divide-gray-xlight">
      {faqItems.map((faq) => (
        <Disclosure key={faq.question} as="div">
          {({ open }) => (
            <>
              <DisclosureButton className="flex w-full justify-between items-center text-left py-5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-light focus-visible:ring-offset-2 rounded">
                <Typography
                  component="span"
                  className="text-primary-main font-semibold text-base sm:text-lg pr-4"
                >
                  {faq.question}
                </Typography>
                <div
                  className={cx(
                    'w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200',
                    { 'rotate-180': open }
                  )}
                >
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className="text-primary-main/60 text-sm"
                  />
                </div>
              </DisclosureButton>
              <DisclosurePanel className="pb-5">
                <Typography
                  component="p"
                  className="text-primary-main/70 leading-relaxed text-[15px]"
                >
                  {faq.answer}
                </Typography>
              </DisclosurePanel>
            </>
          )}
        </Disclosure>
      ))}
    </div>
  );
}
